import { ChangeDetectionStrategy, Component, inject, input, output, viewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IncidentFormControls } from '../../../../../types';
import { PanFilepickerComponent } from '../../../../../components/pan-filepicker/pan-filepicker.component';
import { ModalService } from '../../../../../components/pan-modal/modal.service';
import { ReviewFormService } from '../review-form.service';

@Component({
  selector: 'app-review-form-incident-photos',
  templateUrl: './review-form-incident-photos.component.html',
  styleUrl: './review-form-incident-photos.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ReviewFormIncidentPhotosComponent {
  private modalService = inject(ModalService);
  public formService = inject(ReviewFormService);

  private uploadField = viewChild<PanFilepickerComponent>('uploadField');

  public imageUrls = input<string[]>([]);
  public hasKioskPhoto = input<boolean>();
  public form = input<FormGroup<IncidentFormControls> | undefined>();
  public upload = output<File[]>();

  public reset(): void {
    this.uploadField()?.clear();
  }

  public removeLink(link: string): void {
    const control = this.formService.form.controls.existingUniqueInstancePhoto;
    const index = control.value.indexOf(link);
    if (index !== -1) control.removeAt(index);
    this.modalService.removeModal();
  }

  public removeImageUrl(imageUrl: string): void {
    const index = this.imageUrls().indexOf(imageUrl);
    if (index === -1) return;
    this.formService.removeFileAt(this.formService.form.controls.uniqueInstancePhoto, this.formService.uniqueInstancePhotoUrls, index);
    this.modalService.removeModal();
  }
}
